import React, { FC } from 'react'
import { observer } from 'mobx-react'
import { IonModal, IonContent } from '@ionic/react'
import { format } from '@dt/fe-utils'
import { modalLayer } from '@utils'
import { CouponItem, CouponDetail } from '@cps'
import ModalHeader from '../ModalHeader'
import i18n from 'i18next'
import './index.scss'

interface IProps {
  info: any;
  cnt: number;
  couponMap: any;
  reject?: () => void;
  resolve?: () => void;
}

const GiveDetail: FC<IProps> = (props: IProps) => {
  const { info, couponMap, cnt, resolve } = props
  return (
    <IonModal
      cssClass='give-detail-modal height620-modal'
      isOpen
      showBackdrop
      backdropDismiss
      onDidDismiss={resolve}
    >
      <ModalHeader title={i18n.t('cart.details')} onClose={resolve}></ModalHeader>
      <IonContent className='modal-content'>
        <div className='detail-body'>
          <div className='title'>
            {
              !!info.money && <span>{i18n.t('mkt.record.recharge')} {format.toPrice(info && info.money)} </span>
            }
            {
              !!info.moneyGive && <span> {i18n.t('mkt.giftCard.giveAway')} {format.toPrice(info && info.moneyGive)} </span>
            }
            {
              cnt > 0 && <span>{info.money ? ',' : ''}{i18n.t('mkt.member.coupons', { num: cnt })}</span>
            }
          </div>
          {
            cnt > 0 && info.coupons.map((item: any, index: number) => {
              const hasItem: any = couponMap[item.couponId]
              return hasItem && (
                <div className='coupon-block' key={`${index}-${item.couponId}`}>
                  <CouponItem type='get' couponInfo={hasItem} cnt={item.couponCnt > 1 ? item.couponCnt : ''} onDetail={() => modalLayer(CouponDetail, { type: 'get', couponInfo: hasItem }, 'couponDetail')}></CouponItem>
                </div>)
            })
          }
        </div>
      </IonContent>
    </IonModal>
  )
}

export default observer(GiveDetail)
